<template>
  <div>
    <section class="page-content rx-page-application">
      <div class="row">
        <div class="col-md-12">
          <form action @submit.prevent="next">
            <article class="form-heading title-section form-section flex">
              <h1 class="form-title">Additional Locations </h1>
            </article>
            <article class="form-section">
              <div class="input-section">
                <div class="row pb-3">
                  <div class="col-md-12">
                    <div class="radio orep-radio-wrapper solo-checkbox" style="padding-top: 20px">
                      <label class="orep-label ml-1">
                        <input
                            type="checkbox"
                            name="checkIfNoAdditionalLocations"
                            class="orep-radio w-40"
                            v-model="insuranceAgentApplication.checkIfNoAdditionalLocations"
                        >
                        <span class="radio-span solo-checkbox-span" style="color: #046085">
                    No Additional Locations
                  </span>
                      </label>
                    </div>
                  </div>
                </div>
                <div v-if="!insuranceAgentApplication.checkIfNoAdditionalLocations" class="row pb-3">
                  <div class="col-md-12">
                    <label for class="orep-label mb-0 ml-1">
                      <span class="mr-1">1.</span>
                      Street
                    </label>
                    <input
                        type="text"
                        name="streetOne"
                        v-model="insuranceAgentApplication.streetOne"
                        class="orep-text-input w-100"
                        @input="validateBeforeSubmit()"
                    >
                  </div>
                </div>
                <div v-if="!insuranceAgentApplication.checkIfNoAdditionalLocations" class="row pb-3">
                  <div class="col-md-2">
                    <label for class="orep-label mb-0 ml-1">
                      City:
                    </label>
                    <input
                        type="text"
                        name="cityOne"
                        v-model="insuranceAgentApplication.cityOne"
                        class="orep-text-input w-100"
                        @input="validateBeforeSubmit()"
                    >
                  </div>
                  <div class="col-md-2">
                    <label for class="orep-label mb-0 ml-1">
                      State:
                    </label>
                    <select
                        class="orep-select w-100"
                        style="height: 40px; width: 100%;"
                        name="stateOne"
                        v-model="insuranceAgentApplication.stateOne"
                        @change="validateBeforeSubmit()"
                    >
                      <option v-for="(item, key) in states" :value="key">
                        {{item}}
                      </option>
                    </select>
                  </div>
                  <div class="col-md-2">
                    <label for class="orep-label mb-0 ml-1">
                      ZIP Code:
                    </label>
                    <input
                        type="text"
                        name="zipCodeOne"
                        v-model="insuranceAgentApplication.zipCodeOne"
                        class="orep-text-input w-100"
                        @input="validateBeforeSubmit()"
                    >
                  </div>
                  <div class="col-md-3">
                    <label for class="orep-label mb-0">
                      <span class="qtn mrpx-5"></span>Phone:
                    </label>
                    <input
                        type="text"
                        name="phoneOne"
                        v-model="insuranceAgentApplication.phoneOne"
                        class="orep-text-input w-100"
                        @input="validateBeforeSubmit()"
                    >
                  </div>
                  <div class="col-md-3">
                    <label for class="orep-label mb-0">
                      <span class="qtn mrpx-5"></span>Fax:
                    </label>
                    <input
                        type="text"
                        name="faxOne"
                        v-model="insuranceAgentApplication.faxOne"
                        class="orep-text-input w-100"
                        @input="validateBeforeSubmit()"
                    >
                  </div>
                </div>
                <div v-if="!insuranceAgentApplication.checkIfNoAdditionalLocations" class="row pb-3">
                  <div class="col-md-12">
                    <label for class="orep-label mb-0 ml-1">
                      <span class="mr-1">2.</span>
                      Street
                    </label>
                    <input
                        type="text"
                        name="streetTwo"
                        v-model="insuranceAgentApplication.streetTwo"
                        class="orep-text-input w-100"
                        @input="validateBeforeSubmit()"
                    >
                  </div>
                </div>
                <div v-if="!insuranceAgentApplication.checkIfNoAdditionalLocations" class="row pb-3">
                  <div class="col-md-2">
                    <label for class="orep-label mb-0 ml-1">
                      City:
                    </label>
                    <input
                        type="text"
                        name="cityTwo"
                        v-model="insuranceAgentApplication.cityTwo"
                        class="orep-text-input w-100"
                        @input="validateBeforeSubmit()"
                    >
                  </div>
                  <div class="col-md-2">
                    <label for class="orep-label mb-0 ml-1">
                      State:
                    </label>
                    <select
                        class="orep-select w-100"
                        style="height: 40px; width: 100%;"
                        name="stateTwo"
                        v-model="insuranceAgentApplication.stateTwo"
                        @change="validateBeforeSubmit()"
                    >
                      <option v-for="(item, key) in states" :value="key">
                        {{item}}
                      </option>
                    </select>
                  </div>
                  <div class="col-md-2">
                    <label for class="orep-label mb-0 ml-1">
                      ZIP Code:
                    </label>
                    <input
                        type="text"
                        name="zipCodeTwo"
                        v-model="insuranceAgentApplication.zipCodeTwo"
                        class="orep-text-input w-100"
                        @input="validateBeforeSubmit()"
                    >
                  </div>
                  <div class="col-md-3">
                    <label for class="orep-label mb-0">
                      <span class="qtn mrpx-5"></span>Phone:
                    </label>
                    <input
                        type="text"
                        name="phoneTwo"
                        v-model="insuranceAgentApplication.phoneTwo"
                        class="orep-text-input w-100"
                        @input="validateBeforeSubmit()"
                    >
                  </div>
                  <div class="col-md-3">
                    <label for class="orep-label mb-0">
                      <span class="qtn mrpx-5"></span>Fax:
                    </label>
                    <input
                        type="text"
                        name="faxTwo"
                        v-model="insuranceAgentApplication.faxTwo"
                        class="orep-text-input w-100"
                        @input="validateBeforeSubmit()"
                    >
                  </div>
                </div>
                <div v-if="!insuranceAgentApplication.checkIfNoAdditionalLocations" class="row pb-3">
                  <div class="col-md-12">
                    <label for class="orep-label mb-0 ml-1">
                      <span class="mr-1">3.</span>
                      Street
                    </label>
                    <input
                        type="text"
                        name="streetThree"
                        v-model="insuranceAgentApplication.streetThree"
                        class="orep-text-input w-100"
                        @input="validateBeforeSubmit()"
                    >
                  </div>
                </div>
                <div v-if="!insuranceAgentApplication.checkIfNoAdditionalLocations" class="row pb-3">
                  <div class="col-md-2">
                    <label for class="orep-label mb-0 ml-1">
                      City:
                    </label>
                    <input
                        type="text"
                        name="cityThree"
                        v-model="insuranceAgentApplication.cityThree"
                        class="orep-text-input w-100"
                        @input="validateBeforeSubmit()"
                    >
                  </div>
                  <div class="col-md-2">
                    <label for class="orep-label mb-0 ml-1">
                      State:
                    </label>
                    <select
                        class="orep-select w-100"
                        style="height: 40px; width: 100%;"
                        name="stateThree"
                        v-model="insuranceAgentApplication.stateThree"
                        @change="validateBeforeSubmit()"
                    >
                      <option v-for="(item, key) in states" :value="key">
                        {{item}}
                      </option>
                    </select>
                  </div>
                  <div class="col-md-2">
                    <label for class="orep-label mb-0 ml-1">
                      ZIP Code:
                    </label>
                    <input
                        type="text"
                        name="zipCodeThree"
                        v-model="insuranceAgentApplication.zipCodeThree"
                        class="orep-text-input w-100"
                        @input="validateBeforeSubmit()"
                    >
                  </div>
                  <div class="col-md-3">
                    <label for class="orep-label mb-0">
                      <span class="qtn mrpx-5"></span>Phone:
                    </label>
                    <input
                        type="text"
                        name="phoneThree"
                        v-model="insuranceAgentApplication.phoneThree"
                        class="orep-text-input w-100"
                        @input="validateBeforeSubmit()"
                    >
                  </div>
                  <div class="col-md-3">
                    <label for class="orep-label mb-0">
                      <span class="qtn mrpx-5"></span>Fax:
                    </label>
                    <input
                        type="text"
                        name="faxThree"
                        v-model="insuranceAgentApplication.faxThree"
                        class="orep-text-input w-100"
                        @input="validateBeforeSubmit()"
                    >
                  </div>
                </div>
              </div>
            </article>

            <article class="form-heading title-section form-section flex">
              <h1 class="form-title"> PRIOR COVERAGE  </h1>
            </article>
            <article class="input-section form-section">
              <div class="row">
                <div class="col-md-9 col-sm-12">
                  <label for class="orep-label">
                    <span class="mr-1">1. </span>
                    Do you currently have E&O Coverage?
                  </label>
                </div>
                <div class="col-md-3 d-flex flex-column">
                  <div class="d-flex flex-row">
                    <div class="radio orep-radio-wrapper">
                      <label>
                        <input
                            type="radio"
                            name="doYouhaveEoCoverage"
                            value="true"
                            class="orep-radio"
                            v-validate="'required'"
                            @change="validateBeforeSubmit()"
                            v-model="insuranceAgentApplication.doYouhaveEoCoverage"
                        >
                        <span class="radio-span">Yes</span>
                      </label>
                    </div>
                    <div class="radio orep-radio-wrapper">
                      <label>
                        <input
                            type="radio"
                            name="doYouhaveEoCoverage"
                            value="false"
                            class="orep-radio"
                            @change="validateBeforeSubmit()"
                            v-model="insuranceAgentApplication.doYouhaveEoCoverage"
                        >
                        <span class="radio-span">No</span>
                      </label>
                    </div>
                  </div>
                  <span
                      v-show="errors.has('doYouhaveEoCoverage')"
                      class="help is-danger form-errors text-danger"
                  >{{ errors.first('doYouhaveEoCoverage') | filterText }}</span>
                </div>
              </div>

              <div class="row mb-3">
                <div class="col-md-4 col-sm-12">
                  <label for class="orep-label mb-0 ml-1">
                    What is the expiration date?
                  </label>
                </div>
                <div class="col-md-8 col-sm-12">
                  <datepicker
                      name="expirationDate"
                      v-model="insuranceAgentApplication.expirationDate"
                      format="MM/dd/yyyy"
                      input-format="MM/dd/yyyy"
                      input-class="orep-text-input-date"
                      @input="validateBeforeSubmit()"
                      :clearButton="false"
                      :value="computedDates"
                      :typeable="true"
                      required
                  ></datepicker>
                </div>
              </div>

              <div class="row mb-3">
                <div class="col-md-4 col-sm-12">
                  <label for class="orep-label mb-0 ml-1">
                    What is the retroactive date?
                  </label>
                </div>
                <div class="col-md-8 col-sm-12">
                  <input type="text"
                         name="retroactiveDate"
                         v-model="insuranceAgentApplication.retroactiveDate"
                         class="orep-text-input-date"
                         placeholder="MM/dd/yyyy"
                         @input="validateBeforeSubmit()"
                         required>
                </div>
              </div>
            </article>

            <article class="input-section form-section">
              <div class="row">
                <div class="col-md-9 col-sm-12">
                  <label for class="orep-label">
                    <span class="mr-1">2. </span>
                    Who were you previously insured by?
                  </label>
                </div>
              </div>
              <div class="row pb-3">
                <div class="col-md-auto   d-flex flex-column align-items-center">
                  <label for class="orep-label">
                    Insurer
                  </label>
                  <input
                      type="text"
                      id="insurerOne"
                      name="insurerOne"
                      v-model="insuranceAgentApplication.insurerOne"
                      class="orep-text-input w-100"
                      @input="validateBeforeSubmit()"
                  >
                </div>
                <div class="col-md-2 d-flex flex-column align-items-center"> <!-- Added align-items-center class -->
                  <label for class="orep-label">
                    Policy Period
                  </label>
                  <input
                      type="text"
                      id="policyPeriodOne"
                      name="policyPeriodOne"
                      v-model="insuranceAgentApplication.policyPeriodOne"
                      class="orep-text-input w-100"
                      @input="validateBeforeSubmit()"
                  >
                </div>
                <div class="col-md-3 d-flex flex-column align-items-center"> <!-- Added align-items-center class -->
                  <label for class="orep-label">
                    Limit
                  </label>
                  <input
                      type="text"
                      id="limitOne"
                      name="limitOne"
                      v-model="insuranceAgentApplication.limitOne"
                      class="orep-text-input w-100"
                      @input="validateBeforeSubmit()"
                  >
                </div>
                <div class="col-md-2 d-flex flex-column align-items-center"> <!-- Added align-items-center class -->
                  <label for class="orep-label">
                    Deductible
                  </label>
                  <input
                      type="text"
                      id="deductibleOne"
                      name="deductibleOne"
                      v-model="insuranceAgentApplication.deductibleOne"
                      class="orep-text-input w-100"
                      @input="validateBeforeSubmit()"
                  >
                </div>
                <div class="col-md-2 d-flex flex-column align-items-center">
                  <label for class="orep-label">
                    Premium
                  </label>
                  <input
                      type="text"
                      id="premiumOne"
                      name="premiumOne"
                      v-model="insuranceAgentApplication.premiumOne"
                      class="orep-text-input w-100"
                      @input="validateBeforeSubmit()"
                  >
                </div>
              </div>
              <div class="row pb-3">
                <div class="col-md-auto   d-flex flex-column align-items-center">
                  <input
                      type="text"
                      id="insurerTwo"
                      name="insurerTwo"
                      v-model="insuranceAgentApplication.insurerTwo"
                      class="orep-text-input w-100"
                      @input="validateBeforeSubmit()"
                  >
                </div>
                <div class="col-md-2 d-flex flex-column align-items-center"> <!-- Added align-items-center class -->
                  <input
                      type="text"
                      id="policyPeriodTwo"
                      name="policyPeriodTwo"
                      v-model="insuranceAgentApplication.policyPeriodTwo"
                      class="orep-text-input w-100"
                      @input="validateBeforeSubmit()"
                  >
                </div>
                <div class="col-md-3 d-flex flex-column align-items-center"> <!-- Added align-items-center class -->
                  <input
                      type="text"
                      id="limitTwo"
                      name="limitTwo"
                      v-model="insuranceAgentApplication.limitTwo"
                      class="orep-text-input w-100"
                      @input="validateBeforeSubmit()"
                  >
                </div>
                <div class="col-md-2 d-flex flex-column align-items-center"> <!-- Added align-items-center class -->
                  <input
                      type="text"
                      id="deductibleTwo"
                      name="deductibleTwo"
                      v-model="insuranceAgentApplication.deductibleTwo"
                      class="orep-text-input w-100"
                      @input="validateBeforeSubmit()"
                  >
                </div>
                <div class="col-md-2 d-flex flex-column align-items-center">
                  <input
                      type="text"
                      id="premiumTwo"
                      name="premiumTwo"
                      v-model="insuranceAgentApplication.premiumTwo"
                      class="orep-text-input w-100"
                      @input="validateBeforeSubmit()"
                  >
                </div>
              </div>
              <div class="row pb-3">
                <div class="col-md-auto   d-flex flex-column align-items-center">
                  <input
                      type="text"
                      id="insurerThree"
                      name="insurerThree"
                      v-model="insuranceAgentApplication.insurerThree"
                      class="orep-text-input w-100"
                      @input="validateBeforeSubmit()"
                  >
                </div>
                <div class="col-md-2 d-flex flex-column align-items-center"> <!-- Added align-items-center class -->
                  <input
                      type="text"
                      id="policyPeriodThree"
                      name="policyPeriodThree"
                      v-model="insuranceAgentApplication.policyPeriodThree"
                      class="orep-text-input w-100"
                      @input="validateBeforeSubmit()"
                  >
                </div>
                <div class="col-md-3 d-flex flex-column align-items-center"> <!-- Added align-items-center class -->
                  <input
                      type="text"
                      id="limitThree"
                      name="limitThree"
                      v-model="insuranceAgentApplication.limitThree"
                      class="orep-text-input w-100"
                      @input="validateBeforeSubmit()"
                  >
                </div>
                <div class="col-md-2 d-flex flex-column align-items-center"> <!-- Added align-items-center class -->
                  <input
                      type="text"
                      id="deductibleThree"
                      name="deductibleThree"
                      v-model="insuranceAgentApplication.deductibleThree"
                      class="orep-text-input w-100"
                      @input="validateBeforeSubmit()"
                  >
                </div>
                <div class="col-md-2 d-flex flex-column align-items-center">
                  <input
                      type="text"
                      id="premiumThree"
                      name="premiumThree"
                      v-model="insuranceAgentApplication.premiumThree"
                      class="orep-text-input w-100"
                      @input="validateBeforeSubmit()"
                  >
                </div>
              </div>

            </article>


            <article class="input-section form-section d-flex flex-column">
              <div class="row">
                <div class="col-md-9 col-sm-12">
                  <label for class="orep-label">
                    <span class="mr-1">3.</span>
                    Has your E&O insurance ever been cancelled, renewal refused, or coverage declined?
                  </label>
                </div>
                <div class="col-md-3 d-flex flex-column">
                  <div class="d-flex flex-row">
                    <div class="radio orep-radio-wrapper">
                      <label>
                        <input
                            type="radio"
                            name="hasEoInsuranceDeclined"
                            value="true"
                            class="orep-radio"
                            v-validate="'required'"
                            @change="validateBeforeSubmit()"
                            v-model="insuranceAgentApplication.hasEoInsuranceDeclined"
                        >
                        <span class="radio-span">Yes</span>
                      </label>
                    </div>
                    <div class="radio orep-radio-wrapper">
                      <label>
                        <input
                            type="radio"
                            name="hasEoInsuranceDeclined"
                            value="false"
                            class="orep-radio"
                            @change="validateBeforeSubmit()"
                            v-model="insuranceAgentApplication.hasEoInsuranceDeclined"
                        >
                        <span class="radio-span">No</span>
                      </label>
                    </div>
                  </div>
                  <span
                      v-show="errors.has('hasEoInsuranceDeclined')"
                      class="help is-danger form-errors text-danger"
                  >{{ errors.first('hasEoInsuranceDeclined') | filterText }}</span>
                </div>
              </div>
              <div class="col-md-auto d-flex flex-column" v-if="insuranceAgentApplication.hasEoInsuranceDeclined == true || insuranceAgentApplication.hasEoInsuranceDeclined === 'true'">
                <label class="orep-label text-danger">If Yes, provide details
                </label>

                <input
                    type="text"
                    placeholder="Please explain:"
                    class="orep-text-input js-orep-input"
                    v-if="insuranceAgentApplication.hasEoInsuranceDeclined == true || insuranceAgentApplication.hasEoInsuranceDeclined === 'true'"
                    name="hasEoInsuranceDeclinedDetails"
                    v-model="insuranceAgentApplication.hasEoInsuranceDeclinedDetails"
                    @input="validateBeforeSubmit()"
                >
              </div>
            </article>

            <article class="form-heading title-section form-section flex">
              <h1 class="form-title">  PREMIUM WRITTEN AND COMMISSIONS </h1>
            </article>

            <article class="input-section form-section">
              <div class="row">
                <div class="col-md-10">
                  <label for class="orep-label">
                    <span class="mr-1">1. </span>
                    How much premium did you write last year and what do you estimate over the next 12 months?
                  </label>
                </div>
              </div>
              <table class="w-100">
                <thead>
                <tr>
                  <th></th>
                  <th colspan="2">Previous Complete
                    Calendar Year</th>
                  <th colspan="2">Estimate: next 12 Months</th>
                </tr>
                </thead>
                <tbody>
                <th>
                  Premium:
                </th>
                <td colspan="2">
                  <div class="align-items-center"> <!-- Added align-items-center class -->
                    <input
                        type="number"
                        id="periodOne"
                        name="periodOne"
                        v-model="insuranceAgentApplication.periodOne"
                        class="orep-text-input w-100"
                        v-validate="'required'"
                        @input="validateBeforeSubmit()"
                    >
                  </div>
                </td>
                <td colspan="2">
                  <div class="align-items-center"> <!-- Added align-items-center class -->
                    <input
                        type="number"
                        id="periodTwo"
                        name="periodTwo"
                        v-model="insuranceAgentApplication.periodTwo"
                        class="orep-text-input w-100"
                        v-validate="'required'"
                        @input="validateBeforeSubmit()"
                    >
                  </div>
                </td>
                </tbody>
              </table>
            </article>

            <article class="input-section form-section">
              <div class="row">
                  <label for class="orep-label">
                    <span class="mr-1">2. </span>
                    How much commission did you earn last year and what do you estimate over the next 12 months?
                  </label>
                </div>
              <table class="w-100">
                <thead>
                <tr>
                  <th></th>
                  <th colspan="2">Previous Complete
                    Calendar Year
                  </th>
                  <th colspan="2">Estimate: next 12 Months</th>
                </tr>
                </thead>
                <tbody>
                <th>
                  Commission:
                </th>
                <td colspan="2">
                  <div class="align-items-center"> <!-- Added align-items-center class -->
                    <input
                        type="number"
                        id="estimateCommissionEarnOne"
                        name="estimateCommissionEarnOne"
                        v-model="insuranceAgentApplication.estimateCommissionEarnOne"
                        v-validate="'required'"
                        class="orep-text-input w-100"
                        @input="validateBeforeSubmit()"
                    >
                  </div>
                </td>
                <td colspan="2">
                  <div class="align-items-center"> <!-- Added align-items-center class -->
                    <input
                        type="number"
                        id="estimateCommissionEarnTwo"
                        name="estimateCommissionEarnTwo"
                        v-model="insuranceAgentApplication.estimateCommissionEarnTwo"
                        class="orep-text-input w-100"
                        v-validate="'required'"
                        @input="validateBeforeSubmit()"
                    >
                  </div>
                </td>
                </tbody>
              </table>

            </article>

            <article v-if="insuranceAgentApplication.periodOne > 0 && insuranceAgentApplication.estimateCommissionEarnOne > 0 && (insuranceAgentApplication.comissionRange > 20 || insuranceAgentApplication.comissionRange < 7)" class="input-section form-section">
              <div class="row">
                <label for class="orep-label">
                  Commission Percent: <span class="red-text"> {{ insuranceAgentApplication.comissionRange }} % </span>
                </label>
                <label for class="orep-label">
                  PLEASE VERIFY: <span class="red-text">Most Agents earn between 10% and 20% commission on the premium they write. Your Commission earned falls outside the Normal Range. Congrats! Please double check for accuracy before continuing.</span>
                </label>
              </div>
            </article>


            <article class="input-section form-section">
              <div class="row">
                <div class="col-md-9 col-sm-12">
                  <label for class="orep-label">
                    <span class="mr-1">3. </span>
                    What companies, wholesalers, and MGA's do you do business with?
                  </label>
                </div>
              </div>
              <div class="row pb-3">
                <div class="col-md-auto d-flex flex-column align-items-center">
                  <label for class="orep-label">
                    Name
                  </label>
                  <input
                      type="text"
                      id="businessCompanyNameOne"
                      name="businessCompanyNameOne"
                      v-model="insuranceAgentApplication.businessCompanyNameOne"
                      class="orep-text-input w-100"
                      v-validate="'required'"
                      @input="validateBeforeSubmit()"
                  >
                  <span
                      v-show="errors.has('businessCompanyNameOne')"
                      class="help is-danger form-errors text-danger"
                  >{{ errors.first('businessCompanyNameOne') | filterText }}</span>
                </div>
                <div class="col-md-4 d-flex flex-column align-items-center"> <!-- Added align-items-center class -->
                  <label for class="orep-label">
                    Percentage of Business
                  </label>
                  <input
                      type="text"
                      id="businessPercentageOne"
                      name="businessPercentageOne"
                      v-model="insuranceAgentApplication.businessPercentageOne"
                      class="orep-text-input w-100"
                      v-validate="'required'"
                      @input="validateBeforeSubmit()"
                  >
                  <span
                      v-show="errors.has('businessPercentageOne')"
                      class="help is-danger form-errors text-danger"
                  >{{ errors.first('businessPercentageOne') | filterText }}</span>
                </div>
                <div class="col-md-4 d-flex flex-column align-items-center"> <!-- Added align-items-center class -->
                  <label for class="orep-label">
                    Admitted
                  </label>
                  <div class="d-flex flex-row">
                    <div class="radio orep-radio-wrapper">
                      <label>
                        <input
                            type="radio"
                            name="businessAdmittedOne"
                            id="businessAdmittedOneYes"
                            value="true"
                            class="orep-radio"
                            @change="validateBeforeSubmit()"
                            v-model="insuranceAgentApplication.businessAdmittedOne"
                        >
                        <span class="radio-span">Yes</span>
                      </label>
                    </div>
                    <div class="radio orep-radio-wrapper">
                      <label>
                        <input
                            type="radio"
                            name="businessAdmittedOne"
                            id="businessAdmittedOneNo"
                            value="false"
                            class="orep-radio"
                            @change="validateBeforeSubmit()"
                            v-validate="'required'"
                            v-model="insuranceAgentApplication.businessAdmittedOne"
                        >
                        <span class="radio-span">No</span>
                      </label>
                    </div>
                  </div>
                  <span
                      v-show="errors.has('businessAdmittedOne')"
                      class="help is-danger form-errors text-danger"
                  >{{ errors.first('businessAdmittedOne') | filterText }}</span>
                </div>
              </div>
              <div class="row pb-3">
                <div class="col-md-auto d-flex flex-column align-items-center">
                  <input
                      type="text"
                      id="businessCompanyNameTwo"
                      name="businessCompanyNameTwo"
                      v-model="insuranceAgentApplication.businessCompanyNameTwo"
                      class="orep-text-input w-100"
                      @input="validateBeforeSubmit()"
                  >
                </div>
                <div class="col-md-4 d-flex flex-column align-items-center"> <!-- Added align-items-center class -->
                  <input
                      type="text"
                      id="businessPercentageTwo"
                      name="businessPercentageTwo"
                      v-model="insuranceAgentApplication.businessPercentageTwo"
                      class="orep-text-input w-100"
                      @input="validateBeforeSubmit()"
                  >
                </div>
                <div class="col-md-4 d-flex flex-column align-items-center"> <!-- Added align-items-center class -->
                  <div class="d-flex flex-row">
                    <div class="radio orep-radio-wrapper">
                      <label>
                        <input
                            type="radio"
                            name="businessAdmittedTwo"
                            id="businessAdmittedTwoYes"
                            value="true"
                            class="orep-radio"
                            @change="validateBeforeSubmit()"
                            v-model="insuranceAgentApplication.businessAdmittedTwo"
                        >
                        <span class="radio-span">Yes</span>
                      </label>
                    </div>
                    <div class="radio orep-radio-wrapper">
                      <label>
                        <input
                            type="radio"
                            name="businessAdmittedTwo"
                            id="businessAdmittedTwoNo"
                            value="false"
                            class="orep-radio"
                            @change="validateBeforeSubmit()"
                            v-model="insuranceAgentApplication.businessAdmittedTwo"
                        >
                        <span class="radio-span">No</span>
                      </label>
                    </div>
                  </div>
                </div>
              </div>
              <div class="row pb-3">
                <div class="col-md-auto d-flex flex-column align-items-center">
                  <input
                      type="text"
                      id="businessCompanyNameThree"
                      name="businessCompanyNameThree"
                      v-model="insuranceAgentApplication.businessCompanyNameThree"
                      class="orep-text-input w-100"
                      @input="validateBeforeSubmit()"
                  >
                </div>
                <div class="col-md-4 d-flex flex-column align-items-center"> <!-- Added align-items-center class -->
                  <input
                      type="text"
                      id="businessPercentageThree"
                      name="businessPercentageThree"
                      v-model="insuranceAgentApplication.businessPercentageThree"
                      class="orep-text-input w-100"
                      @input="validateBeforeSubmit()"
                  >
                </div>
                <div class="col-md-4 d-flex flex-column align-items-center"> <!-- Added align-items-center class -->
                  <div class="d-flex flex-row">
                    <div class="radio orep-radio-wrapper">
                      <label>
                        <input
                            type="radio"
                            name="businessAdmittedThree"
                            id="businessAdmittedThreeYes"
                            value="true"
                            class="orep-radio"
                            @change="validateBeforeSubmit()"
                            v-model="insuranceAgentApplication.businessAdmittedThree"
                        >
                        <span class="radio-span">Yes</span>
                      </label>
                    </div>
                    <div class="radio orep-radio-wrapper">
                      <label>
                        <input
                            type="radio"
                            name="businessAdmittedThree"
                            id="businessAdmittedThreeNo"
                            value="false"
                            class="orep-radio"
                            @change="validateBeforeSubmit()"
                            v-model="insuranceAgentApplication.businessAdmittedThree"
                        >
                        <span class="radio-span">No</span>
                      </label>
                    </div>
                  </div>
                </div>
              </div>
              <div class="row pb-3">
                <div class="col-md-auto d-flex flex-column align-items-center">
                  <input
                      type="text"
                      id="businessCompanyNameFour"
                      name="businessCompanyNameFour"
                      v-model="insuranceAgentApplication.businessCompanyNameFour"
                      class="orep-text-input w-100"
                      @input="validateBeforeSubmit()"
                  >
                </div>
                <div class="col-md-4 d-flex flex-column align-items-center"> <!-- Added align-items-center class -->
                  <input
                      type="text"
                      id="businessPercentageFour"
                      name="businessPercentageFour"
                      v-model="insuranceAgentApplication.businessPercentageFour"
                      class="orep-text-input w-100"
                      @input="validateBeforeSubmit()"
                  >
                </div>
                <div class="col-md-4 d-flex flex-column align-items-center"> <!-- Added align-items-center class -->
                  <div class="d-flex flex-row">
                    <div class="radio orep-radio-wrapper">
                      <label>
                        <input
                            type="radio"
                            name="businessAdmittedFour"
                            id="businessAdmittedFourYes"
                            value="true"
                            class="orep-radio"
                            @change="validateBeforeSubmit()"
                            v-model="insuranceAgentApplication.businessAdmittedFour"
                        >
                        <span class="radio-span">Yes</span>
                      </label>
                    </div>
                    <div class="radio orep-radio-wrapper">
                      <label>
                        <input
                            type="radio"
                            name="businessAdmittedFour"
                            id="businessAdmittedFourNo"
                            value="false"
                            class="orep-radio"
                            @change="validateBeforeSubmit()"
                            v-model="insuranceAgentApplication.businessAdmittedFour"
                        >
                        <span class="radio-span">No</span>
                      </label>
                    </div>
                  </div>
                </div>
              </div>
              <div class="row pb-3">
                <div class="col-md-auto d-flex flex-column align-items-center">
                  <input
                      type="text"
                      id="businessCompanyNameFive"
                      name="businessCompanyNameFive"
                      v-model="insuranceAgentApplication.businessCompanyNameFive"
                      class="orep-text-input w-100"
                      @input="validateBeforeSubmit()"
                  >
                </div>
                <div class="col-md-4 d-flex flex-column align-items-center"> <!-- Added align-items-center class -->
                  <input
                      type="text"
                      id="businessPercentageFive"
                      name="businessPercentageFive"
                      v-model="insuranceAgentApplication.businessPercentageFive"
                      class="orep-text-input w-100"
                      @input="validateBeforeSubmit()"
                  >
                </div>
                <div class="col-md-4 d-flex flex-column align-items-center"> <!-- Added align-items-center class -->
                  <div class="d-flex flex-row">
                    <div class="radio orep-radio-wrapper">
                      <label>
                        <input
                            type="radio"
                            name="businessAdmittedFive"
                            id="businessAdmittedFiveYes"
                            value="true"
                            class="orep-radio"
                            @change="validateBeforeSubmit()"
                            v-model="insuranceAgentApplication.businessAdmittedFive"
                        >
                        <span class="radio-span">Yes</span>
                      </label>
                    </div>
                    <div class="radio orep-radio-wrapper">
                      <label>
                        <input
                            type="radio"
                            name="businessAdmittedFive"
                            id="businessAdmittedFiveNo"
                            value="false"
                            class="orep-radio"
                            @change="validateBeforeSubmit()"
                            v-model="insuranceAgentApplication.businessAdmittedFive"
                        >
                        <span class="radio-span">No</span>
                      </label>
                    </div>
                  </div>
                </div>
              </div>
              <div class="row pb-3">
                <div class="col-md-auto d-flex flex-column align-items-center">
                  <input
                      type="text"
                      id="businessCompanyNameSix"
                      name="businessCompanyNameSix"
                      v-model="insuranceAgentApplication.businessCompanyNameSix"
                      class="orep-text-input w-100"
                      @input="validateBeforeSubmit()"
                  >
                </div>
                <div class="col-md-4 d-flex flex-column align-items-center"> <!-- Added align-items-center class -->
                  <input
                      type="text"
                      id="businessPercentageSix"
                      name="businessPercentageSix"
                      v-model="insuranceAgentApplication.businessPercentageSix"
                      class="orep-text-input w-100"
                      @input="validateBeforeSubmit()"
                  >
                </div>
                <div class="col-md-4 d-flex flex-column align-items-center"> <!-- Added align-items-center class -->
                  <div class="d-flex flex-row">
                    <div class="radio orep-radio-wrapper">
                      <label>
                        <input
                            type="radio"
                            name="businessAdmittedSix"
                            id="businessAdmittedSixYes"
                            value="true"
                            class="orep-radio"
                            @change="validateBeforeSubmit()"
                            v-model="insuranceAgentApplication.businessAdmittedSix"
                        >
                        <span class="radio-span">Yes</span>
                      </label>
                    </div>
                    <div class="radio orep-radio-wrapper">
                      <label>
                        <input
                            type="radio"
                            name="businessAdmittedSix"
                            id="businessAdmittedSixNo"
                            value="false"
                            class="orep-radio"
                            @change="validateBeforeSubmit()"
                            v-model="insuranceAgentApplication.businessAdmittedSix"
                        >
                        <span class="radio-span">No</span>
                      </label>
                    </div>
                  </div>
                </div>
              </div>
            </article>

            <article class="input-section form-section d-flex flex-column">
              <div class="row">
                <div class="col-md-9 col-sm-12">
                  <label for class="orep-label">
                    <span class="mr-1">4.</span>
                    Do you specialize in any specific class of business?
                  </label>
                </div>
                <div class="col-md-3 d-flex flex-column">
                  <div class="d-flex flex-row">
                    <div class="radio orep-radio-wrapper">
                      <label>
                        <input
                            type="radio"
                            name="specializeInAnyBusiness"
                            value="true"
                            class="orep-radio"
                            v-validate="'required'"
                            @change="validateBeforeSubmit()"
                            v-model="insuranceAgentApplication.specializeInAnyBusiness"
                        >
                        <span class="radio-span">Yes</span>
                      </label>
                    </div>
                    <div class="radio orep-radio-wrapper">
                      <label>
                        <input
                            type="radio"
                            name="specializeInAnyBusiness"
                            value="false"
                            class="orep-radio"
                            @change="validateBeforeSubmit()"
                            v-model="insuranceAgentApplication.specializeInAnyBusiness"
                        >
                        <span class="radio-span">No</span>
                      </label>
                    </div>
                  </div>
                  <span
                      v-show="errors.has('specializeInAnyBusiness')"
                      class="help is-danger form-errors text-danger"
                  >{{ errors.first('specializeInAnyBusiness') | filterText }}</span>
                </div>
              </div>
              <div class="col-md-auto d-flex flex-column" v-if="insuranceAgentApplication.specializeInAnyBusiness == true || insuranceAgentApplication.specializeInAnyBusiness === 'true'">
                <label class="orep-label text-danger">If Yes, provide details
                </label>

                <input
                    type="text"
                    placeholder="Please explain:"
                    class="orep-text-input js-orep-input"
                    v-if="insuranceAgentApplication.specializeInAnyBusiness == true || insuranceAgentApplication.specializeInAnyBusiness === 'true'"
                    name="specializeInAnyBusinessDetails"
                    v-model="insuranceAgentApplication.specializeInAnyBusinessDetails"
                    @input="validateBeforeSubmit()"
                >
              </div>
            </article>
          </form>
        </div>
      </div>
    </section>
    <div class="row">
      <div class="col-md-12">
        <section class="flex wrap bottom-section">
          <router-link :to="{name:'ibdpro-insurance-agent-application-1'}" class="next-btn back-btn flex mont spaced">
            <i class="fas fa-arrow-left"></i>
            Back
          </router-link>
          <article class="orep-pagination">
            <button @click="prev()" class="pagination-dots"></button>
            <button class="pagination-dots pagination-current"></button>
            <button
              class="pagination-dots"
              :disabled="!state.pageTwoIsValid"
              @click="navigateToNext('ibdpro-insurance-agent-application-3')">
            </button>
            <button
              class="pagination-dots"
              :disabled="!state.pageTwoIsValid || !state.pageThreeIsValid"
              @click="navigateToNext('ibdpro-insurance-agent-application-4')">
            </button>
            <button
              class="pagination-dots"
              :disabled="!state.pageTwoIsValid || !state.pageThreeIsValid || !state.pageFourIsValid"
              @click="navigateToNext('pageTwoIsValid-appraiser-5')">
            </button>
          </article>
          <button type="submit" :disabled="!state.pageTwoIsValid"
            :class="{submitDisabled: !state.pageTwoIsValid}" class="next-btn mont spaced pull-right" @click="navigateToNext('ibdpro-insurance-agent-application-3')">Next</button>
        </section>
      </div>
    </div>
  </div>
</template>

<script>
import $ from "jquery";
import moment from "moment/moment";
import Datepicker from "vuejs-datepicker";
import {STATES} from "@/utils/constants";

export default {
  name: "ibdpro-insurance-agent-application-2",
  data() {
    return {
      states: STATES
    };
  },
  computedDates() {
    return moment(this.value).format('YYYY-MM-D')
  },
  computed: {
    insuranceAgentApplication() {
      return this.$store.state.insuranceAgentApplication.insuranceAgentApplication;
    },
    state() {
      return this.$store.state.insuranceAgentApplication;
    },
    errorMsg() {
      return this.$store.state.insuranceAgentApplication.errorMsg;
    },

    lastRevenueResidentialSales: {
      get: function() {
        return this.insuranceAgentApplication.lastRevenueResidentialSales || '';
      },
      set: function(val) {
        if (val === ''){
          this.insuranceAgentApplication.lastRevenueResidentialSales = 0;
        }
        else {

          this.insuranceAgentApplication.lastRevenueResidentialSales = val;
        }
      }
    },

    lastNumberResidentialSales: {
      get: function () {
        return this.insuranceAgentApplication.lastNumberResidentialSales || '';
      },
      set: function (val) {
        if (val === '') {
          this.insuranceAgentApplication.lastNumberResidentialSales = 0;
        } else {

          this.insuranceAgentApplication.lastNumberResidentialSales = val;
        }
      },
    },

    nextRevenueResidentialSales: {
      get: function () {
        return this.insuranceAgentApplication.nextRevenueResidentialSales || '';
      },
      set: function (val) {
        if (val === '') {
          this.insuranceAgentApplication.nextRevenueResidentialSales = 0;
        } else {

          this.insuranceAgentApplication.nextRevenueResidentialSales = val;
        }
      },
    },

    nextNumberResidentialSales: {
      get: function () {
        return this.insuranceAgentApplication.nextNumberResidentialSales || '';
      },
      set: function (val) {
        if (val === '') {
          this.insuranceAgentApplication.nextNumberResidentialSales = 0;
        } else {

          this.insuranceAgentApplication.nextNumberResidentialSales = val;
        }
      },
    },


    lastRevenueResidentialProperty: {
      get: function () {
        return this.insuranceAgentApplication.lastRevenueResidentialProperty || '';
      },
      set: function (val) {
        if (val === '') {
          this.insuranceAgentApplication.lastRevenueResidentialProperty = 0;
        } else {

          this.insuranceAgentApplication.lastRevenueResidentialProperty = val;
        }
      },
    },

    lastNumberResidentialProperty: {
      get: function () {
        return this.insuranceAgentApplication.lastNumberResidentialProperty || '';
      },
      set: function (val) {
        if (val === '') {
          this.insuranceAgentApplication.lastNumberResidentialProperty = 0;
        } else {

          this.insuranceAgentApplication.lastNumberResidentialProperty = val;
        }
      },
    },

    nextRevenueResidentialProperty: {
      get: function () {
        return this.insuranceAgentApplication.nextRevenueResidentialProperty || '';
      },
      set: function (val) {
        if (val === '') {
          this.insuranceAgentApplication.nextRevenueResidentialProperty = 0;
        } else {

          this.insuranceAgentApplication.nextRevenueResidentialProperty = val;
        }
      },
    },

    nextNumberResidentialProperty: {
      get: function () {
        return this.insuranceAgentApplication.nextNumberResidentialProperty || '';
      },
      set: function (val) {
        if (val === '') {
          this.insuranceAgentApplication.nextNumberResidentialProperty = 0;
        } else {

          this.insuranceAgentApplication.nextNumberResidentialProperty = val;
        }
      },
    },


    lastRevenueResidentialFarm: {
      get: function () {
        return this.insuranceAgentApplication.lastRevenueResidentialFarm || '';
      },
      set: function (val) {
        if (val === '') {
          this.insuranceAgentApplication.lastRevenueResidentialFarm = 0;
        } else {

          this.insuranceAgentApplication.lastRevenueResidentialFarm = val;
        }
      },
    },

    lastNumberResidentialFarm: {
      get: function () {
        return this.insuranceAgentApplication.lastNumberResidentialFarm || '';
      },
      set: function (val) {
        if (val === '') {
          this.insuranceAgentApplication.lastNumberResidentialFarm = 0;
        } else {

          this.insuranceAgentApplication.lastNumberResidentialFarm = val;
        }
      },
    },

    nextRevenueResidentialFarm: {
      get: function () {
        return this.insuranceAgentApplication.nextRevenueResidentialFarm || '';
      },
      set: function (val) {
        if (val === '') {
          this.insuranceAgentApplication.nextRevenueResidentialFarm = 0;
        } else {

          this.insuranceAgentApplication.nextRevenueResidentialFarm = val;
        }
      },
    },

    nextNumberResidentialFarm: {
      get: function () {
        return this.insuranceAgentApplication.nextNumberResidentialFarm || '';
      },
      set: function (val) {
        if (val === '') {
          this.insuranceAgentApplication.nextNumberResidentialFarm = 0;
        } else {

          this.insuranceAgentApplication.nextNumberResidentialFarm = val;
        }
      },
    },


    lastRevenueOwnedResidentialRaw: {
      get: function () {
        return this.insuranceAgentApplication.lastRevenueOwnedResidentialRaw || '';
      },
      set: function (val) {
        if (val === '') {
          this.insuranceAgentApplication.lastRevenueOwnedResidentialRaw = 0;
        } else {

          this.insuranceAgentApplication.lastRevenueOwnedResidentialRaw = val;
        }
      },
    },

    lastNumberOwnedResidentialRaw: {
      get: function () {
        return this.insuranceAgentApplication.lastNumberOwnedResidentialRaw || '';
      },
      set: function (val) {
        if (val === '') {
          this.insuranceAgentApplication.lastNumberOwnedResidentialRaw = 0;
        } else {

          this.insuranceAgentApplication.lastNumberOwnedResidentialRaw = val;
        }
      },
    },

    nextRevenueOwnedResidentialRaw: {
      get: function () {
        return this.insuranceAgentApplication.nextRevenueOwnedResidentialRaw || '';
      },
      set: function (val) {
        if (val === '') {
          this.insuranceAgentApplication.nextRevenueOwnedResidentialRaw = 0;
        } else {

          this.insuranceAgentApplication.nextRevenueOwnedResidentialRaw = val;
        }
      },
    },

    nextNumberOwnedResidentialRaw: {
      get: function () {
        return this.insuranceAgentApplication.nextNumberOwnedResidentialRaw || '';
      },
      set: function (val) {
        if (val === '') {
          this.insuranceAgentApplication.nextNumberOwnedResidentialRaw = 0;
        } else {

          this.insuranceAgentApplication.nextNumberOwnedResidentialRaw = val;
        }
      },
    },


    lastRevenueOwnedResidentialAppraisals: {
      get: function () {
        return this.insuranceAgentApplication.lastRevenueOwnedResidentialAppraisals || '';
      },
      set: function (val) {
        if (val === '') {
          this.insuranceAgentApplication.lastRevenueOwnedResidentialAppraisals = 0;
        } else {

          this.insuranceAgentApplication.lastRevenueOwnedResidentialAppraisals = val;
        }
      },
    },

    lastNumberOwnedResidentialAppraisals: {
      get: function () {
        return this.insuranceAgentApplication.lastNumberOwnedResidentialAppraisals || '';
      },
      set: function (val) {
        if (val === '') {
          this.insuranceAgentApplication.lastNumberOwnedResidentialAppraisals = 0;
        } else {

          this.insuranceAgentApplication.lastNumberOwnedResidentialAppraisals = val;
        }
      },
    },

    nextRevenueOwnedResidentialAppraisals: {
      get: function () {
        return this.insuranceAgentApplication.nextRevenueOwnedResidentialAppraisals || '';
      },
      set: function (val) {
        if (val === '') {
          this.insuranceAgentApplication.nextRevenueOwnedResidentialAppraisals = 0;
        } else {

          this.insuranceAgentApplication.nextRevenueOwnedResidentialAppraisals = val;
        }
      },
    },

    nextNumberOwnedResidentialAppraisals: {
      get: function () {
        return this.insuranceAgentApplication.nextNumberOwnedResidentialAppraisals || '';
      },
      set: function (val) {
        if (val === '') {
          this.insuranceAgentApplication.nextNumberOwnedResidentialAppraisals = 0;
        } else {

          this.insuranceAgentApplication.nextNumberOwnedResidentialAppraisals = val;
        }
      },
    },

    lastRevenueCommercialSales: {
      get: function () {
        return this.insuranceAgentApplication.lastRevenueCommercialSales || '';
      },
      set: function (val) {
        if (val === '') {
          this.insuranceAgentApplication.lastRevenueCommercialSales = 0;
        } else {

          this.insuranceAgentApplication.lastRevenueCommercialSales = val;
        }
      },
    },

    lastNumberCommercialSales: {
      get: function () {
        return this.insuranceAgentApplication.lastNumberCommercialSales || '';
      },
      set: function (val) {
        if (val === '') {
          this.insuranceAgentApplication.lastNumberCommercialSales = 0;
        } else {

          this.insuranceAgentApplication.lastNumberCommercialSales = val;
        }
      },
    },

    nextRevenueCommercialSales: {
      get: function () {
        return this.insuranceAgentApplication.nextRevenueCommercialSales || '';
      },
      set: function (val) {
        if (val === '') {
          this.insuranceAgentApplication.nextRevenueCommercialSales = 0;
        } else {

          this.insuranceAgentApplication.nextRevenueCommercialSales = val;
        }
      },
    },

    nextNumberCommercialSales: {
      get: function () {
        return this.insuranceAgentApplication.nextNumberCommercialSales || '';
      },
      set: function (val) {
        if (val === '') {
          this.insuranceAgentApplication.nextNumberCommercialSales = 0;
        } else {

          this.insuranceAgentApplication.nextNumberCommercialSales = val;
        }
      },
    },

    lastRevenueCommercialProperty: {
      get: function () {
        return this.insuranceAgentApplication.lastRevenueCommercialProperty || '';
      },
      set: function (val) {
        if (val === '') {
          this.insuranceAgentApplication.lastRevenueCommercialProperty = 0;
        } else {

          this.insuranceAgentApplication.lastRevenueCommercialProperty = val;
        }
      },
    },

    lastNumberCommercialProperty: {
      get: function () {
        return this.insuranceAgentApplication.lastNumberCommercialProperty || '';
      },
      set: function (val) {
        if (val === '') {
          this.insuranceAgentApplication.lastNumberCommercialProperty = 0;
        } else {

          this.insuranceAgentApplication.lastNumberCommercialProperty = val;
        }
      },
    },

    nextRevenueCommercialProperty: {
      get: function () {
        return this.insuranceAgentApplication.nextRevenueCommercialProperty || '';
      },
      set: function (val) {
        if (val === '') {
          this.insuranceAgentApplication.nextRevenueCommercialProperty = 0;
        } else {

          this.insuranceAgentApplication.nextRevenueCommercialProperty = val;
        }
      },
    },

    nextNumberCommercialProperty: {
      get: function () {
        return this.insuranceAgentApplication.nextNumberCommercialProperty || '';
      },
      set: function (val) {
        if (val === '') {
          this.insuranceAgentApplication.nextNumberCommercialProperty = 0;
        } else {

          this.insuranceAgentApplication.nextNumberCommercialProperty = val;
        }
      },
    },

    lastRevenueCommercialFarm: {
      get: function () {
        return this.insuranceAgentApplication.lastRevenueCommercialFarm || '';
      },
      set: function (val) {
        if (val === '') {
          this.insuranceAgentApplication.lastRevenueCommercialFarm = 0;
        } else {

          this.insuranceAgentApplication.lastRevenueCommercialFarm = val;
        }
      },
    },

    lastNumberCommercialFarm: {
      get: function () {
        return this.insuranceAgentApplication.lastNumberCommercialFarm || '';
      },
      set: function (val) {
        if (val === '') {
          this.insuranceAgentApplication.lastNumberCommercialFarm = 0;
        } else {

          this.insuranceAgentApplication.lastNumberCommercialFarm = val;
        }
      },
    },

    nextRevenueCommercialFarm: {
      get: function () {
        return this.insuranceAgentApplication.nextRevenueCommercialFarm || '';
      },
      set: function (val) {
        if (val === '') {
          this.insuranceAgentApplication.nextRevenueCommercialFarm = 0;
        } else {

          this.insuranceAgentApplication.nextRevenueCommercialFarm = val;
        }
      },
    },

    nextNumberCommercialFarm: {
      get: function () {
        return this.insuranceAgentApplication.nextNumberCommercialFarm || '';
      },
      set: function (val) {
        if (val === '') {
          this.insuranceAgentApplication.nextNumberCommercialFarm = 0;
        } else {

          this.insuranceAgentApplication.nextNumberCommercialFarm = val;
        }
      },
    },

    lastRevenueOwnedCommercialRaw: {
      get: function () {
        return this.insuranceAgentApplication.lastRevenueOwnedCommercialRaw || '';
      },
      set: function (val) {
        if (val === '') {
          this.insuranceAgentApplication.lastRevenueOwnedCommercialRaw = 0;
        } else {

          this.insuranceAgentApplication.lastRevenueOwnedCommercialRaw = val;
        }
      },
    },

    lastNumberOwnedCommercialRaw: {
      get: function () {
        return this.insuranceAgentApplication.lastNumberOwnedCommercialRaw || '';
      },
      set: function (val) {
        if (val === '') {
          this.insuranceAgentApplication.lastNumberOwnedCommercialRaw = 0;
        } else {

          this.insuranceAgentApplication.lastNumberOwnedCommercialRaw = val;
        }
      },
    },

    nextRevenueOwnedCommercialRaw: {
      get: function () {
        return this.insuranceAgentApplication.nextRevenueOwnedCommercialRaw || '';
      },
      set: function (val) {
        if (val === '') {
          this.insuranceAgentApplication.nextRevenueOwnedCommercialRaw = 0;
        } else {

          this.insuranceAgentApplication.nextRevenueOwnedCommercialRaw = val;
        }
      },
    },

    nextNumberOwnedCommercialRaw: {
      get: function () {
        return this.insuranceAgentApplication.nextNumberOwnedCommercialRaw || '';
      },
      set: function (val) {
        if (val === '') {
          this.insuranceAgentApplication.nextNumberOwnedCommercialRaw = 0;
        } else {

          this.insuranceAgentApplication.nextNumberOwnedCommercialRaw = val;
        }
      },
    },



    lastRevenueOwnedCommercialAppraisals: {
      get: function () {
        return this.insuranceAgentApplication.lastRevenueOwnedCommercialAppraisals || '';
      },
      set: function (val) {
        if (val === '') {
          this.insuranceAgentApplication.lastRevenueOwnedCommercialAppraisals = 0;
        } else {

          this.insuranceAgentApplication.lastRevenueOwnedCommercialAppraisals = val;
        }
      },
    },

    lastNumberOwnedCommercialAppraisals: {
      get: function () {
        return this.insuranceAgentApplication.lastNumberOwnedCommercialAppraisals || '';
      },
      set: function (val) {
        if (val === '') {
          this.insuranceAgentApplication.lastNumberOwnedCommercialAppraisals = 0;
        } else {

          this.insuranceAgentApplication.lastNumberOwnedCommercialAppraisals = val;
        }
      },
    },

    nextRevenueOwnedCommercialAppraisals: {
      get: function () {
        return this.insuranceAgentApplication.nextRevenueOwnedCommercialAppraisals || '';
      },
      set: function (val) {
        if (val === '') {
          this.insuranceAgentApplication.nextRevenueOwnedCommercialAppraisals = 0;
        } else {

          this.insuranceAgentApplication.nextRevenueOwnedCommercialAppraisals = val;
        }
      },
    },

    nextNumberOwnedCommercialAppraisals: {
      get: function () {
        return this.insuranceAgentApplication.nextNumberOwnedCommercialAppraisals || '';
      },
      set: function (val) {
        if (val === '') {
          this.insuranceAgentApplication.nextNumberOwnedCommercialAppraisals = 0;
        } else {

          this.insuranceAgentApplication.nextNumberOwnedCommercialAppraisals = val;
        }
      },
    },

    lastRevenuePropertyManagement: {
      get: function () {
        return this.insuranceAgentApplication.lastRevenuePropertyManagement || '';
      },
      set: function (val) {
        if (val === '') {
          this.insuranceAgentApplication.lastRevenuePropertyManagement = 0;
        } else {

          this.insuranceAgentApplication.lastRevenuePropertyManagement = val;
        }
      },
    },
    lastRevenueSalesOfBusiness: {
      get: function () {
        return this.insuranceAgentApplication.lastRevenueSalesOfBusiness || '';
      },
      set: function (val) {
        if (val === '') {
          this.insuranceAgentApplication.lastRevenueSalesOfBusiness = 0;
        } else {

          this.insuranceAgentApplication.lastRevenueSalesOfBusiness = val;
        }
      },
    },
    lastRevenueMortgageBrokering: {
      get: function () {
        return this.insuranceAgentApplication.lastRevenueMortgageBrokering || '';
      },
      set: function (val) {
        if (val === '') {
          this.insuranceAgentApplication.lastRevenueMortgageBrokering = 0;
        } else {

          this.insuranceAgentApplication.lastRevenueMortgageBrokering = val;
        }
      },
    },
    lastRevenueRealEstateConsulting: {
      get: function () {
        return this.insuranceAgentApplication.lastRevenueRealEstateConsulting || '';
      },
      set: function (val) {
        if (val === '') {
          this.insuranceAgentApplication.lastRevenueRealEstateConsulting = 0;
        } else {

          this.insuranceAgentApplication.lastRevenueRealEstateConsulting = val;
        }
      },
    },
    lastRevenueOther: {
      get: function () {
        return this.insuranceAgentApplication.lastRevenueOther || '';
      },
      set: function (val) {
        if (val === '') {
          this.insuranceAgentApplication.lastRevenueOther = 0;
        } else {

          this.insuranceAgentApplication.lastRevenueOther = val;
        }
      },
    },
    lastNumberPropertyManagement: {
      get: function () {
        return this.insuranceAgentApplication.lastNumberPropertyManagement || '';
      },
      set: function (val) {
        if (val === '') {
          this.insuranceAgentApplication.lastNumberPropertyManagement = 0;
        } else {

          this.insuranceAgentApplication.lastNumberPropertyManagement = val;
        }
      },
    },
    lastNumberSalesOfBusiness: {
      get: function () {
        return this.insuranceAgentApplication.lastNumberSalesOfBusiness || '';
      },
      set: function (val) {
        if (val === '') {
          this.insuranceAgentApplication.lastNumberSalesOfBusiness = 0;
        } else {

          this.insuranceAgentApplication.lastNumberSalesOfBusiness = val;
        }
      },
    },
    lastNumberMortgageBrokering: {
      get: function () {
        return this.insuranceAgentApplication.lastNumberMortgageBrokering || '';
      },
      set: function (val) {
        if (val === '') {
          this.insuranceAgentApplication.lastNumberMortgageBrokering = 0;
        } else {

          this.insuranceAgentApplication.lastNumberMortgageBrokering = val;
        }
      },
    },
    lastNumberRealEstateConsulting: {
      get: function () {
        return this.insuranceAgentApplication.lastNumberRealEstateConsulting || '';
      },
      set: function (val) {
        if (val === '') {
          this.insuranceAgentApplication.lastNumberRealEstateConsulting = 0;
        } else {

          this.insuranceAgentApplication.lastNumberRealEstateConsulting = val;
        }
      },
    },
    lastNumberOther: {
      get: function () {
        return this.insuranceAgentApplication.lastNumberOther || '';
      },
      set: function (val) {
        if (val === '') {
          this.insuranceAgentApplication.lastNumberOther = 0;
        } else {

          this.insuranceAgentApplication.lastNumberOther = val;
        }
      },
    },
    nextRevenuePropertyManagement: {
      get: function () {
        return this.insuranceAgentApplication.nextRevenuePropertyManagement || '';
      },
      set: function (val) {
        if (val === '') {
          this.insuranceAgentApplication.nextRevenuePropertyManagement = 0;
        } else {

          this.insuranceAgentApplication.nextRevenuePropertyManagement = val;
        }
      },
    },
    nextRevenueSalesOfBusiness: {
      get: function () {
        return this.insuranceAgentApplication.nextRevenueSalesOfBusiness || '';
      },
      set: function (val) {
        if (val === '') {
          this.insuranceAgentApplication.nextRevenueSalesOfBusiness = 0;
        } else {

          this.insuranceAgentApplication.nextRevenueSalesOfBusiness = val;
        }
      },
    },
    nextRevenueMortgageBrokering: {
      get: function () {
        return this.insuranceAgentApplication.nextRevenueMortgageBrokering || '';
      },
      set: function (val) {
        if (val === '') {
          this.insuranceAgentApplication.nextRevenueMortgageBrokering = 0;
        } else {

          this.insuranceAgentApplication.nextRevenueMortgageBrokering = val;
        }
      },
    },
    nextRevenueRealEstateConsulting: {
      get: function () {
        return this.insuranceAgentApplication.nextRevenueRealEstateConsulting || '';
      },
      set: function (val) {
        if (val === '') {
          this.insuranceAgentApplication.nextRevenueRealEstateConsulting = 0;
        } else {

          this.insuranceAgentApplication.nextRevenueRealEstateConsulting = val;
        }
      },
    },
    nextRevenueOther: {
      get: function () {
        return this.insuranceAgentApplication.nextRevenueOther || '';
      },
      set: function (val) {
        if (val === '') {
          this.insuranceAgentApplication.nextRevenueOther = 0;
        } else {

          this.insuranceAgentApplication.nextRevenueOther = val;
        }
      },
    },
    nextNumberPropertyManagement: {
      get: function () {
        return this.insuranceAgentApplication.nextNumberPropertyManagement || '';
      },
      set: function (val) {
        if (val === '') {
          this.insuranceAgentApplication.nextNumberPropertyManagement = 0;
        } else {

          this.insuranceAgentApplication.nextNumberPropertyManagement = val;
        }
      },
    },
    nextNumberSalesOfBusiness: {
      get: function () {
        return this.insuranceAgentApplication.nextNumberSalesOfBusiness || '';
      },
      set: function (val) {
        if (val === '') {
          this.insuranceAgentApplication.nextNumberSalesOfBusiness = 0;
        } else {

          this.insuranceAgentApplication.nextNumberSalesOfBusiness = val;
        }
      },
    },
    nextNumberMortgageBrokering: {
      get: function () {
        return this.insuranceAgentApplication.nextNumberMortgageBrokering || '';
      },
      set: function (val) {
        if (val === '') {
          this.insuranceAgentApplication.nextNumberMortgageBrokering = 0;
        } else {

          this.insuranceAgentApplication.nextNumberMortgageBrokering = val;
        }
      },
    },
    nextNumberRealEstateConsulting: {
      get: function () {
        return this.insuranceAgentApplication.nextNumberRealEstateConsulting || '';
      },
      set: function (val) {
        if (val === '') {
          this.insuranceAgentApplication.nextNumberRealEstateConsulting = 0;
        } else {

          this.insuranceAgentApplication.nextNumberRealEstateConsulting = val;
        }
      },
    },
    nextNumberOther: {
      get: function () {
        return this.insuranceAgentApplication.nextNumberOther || '';
      },
      set: function (val) {
        if (val === '') {
          this.insuranceAgentApplication.nextNumberOther = 0;
        } else {

          this.insuranceAgentApplication.nextNumberOther = val;
        }
      },
    },
    //
    // totalLastRevenue() {
    //   return (
    //     Number(this.totalLastRevenueResidentialAppraisal) +
    //     Number(this.totalLastRevenueCommercialAppraisal) +
    //     Number(this.totalLastRevenueRealEstateSales) +
    //     Number(this.totalLastRevenueOtherServices)
    //   ).toFixed(0);
    // },
    // totalLastNumber() {
    //   return (
    //     Number(this.totalLastNumberResidentialAppraisal) +
    //     Number(this.totalLastNumberCommercialAppraisal) +
    //     Number(this.totalLastNumberRealEstateSales) +
    //     Number(this.totalLastNumberOtherServices)
    //   ).toFixed(0);
    // },
    // totalNextRevenue() {
    //   return (
    //     Number(this.totalNextRevenueResidentialAppraisal) +
    //     Number(this.totalNextRevenueCommercialAppraisal) +
    //     Number(this.totalNextRevenueRealEstateSales) +
    //     Number(this.totalNextRevenueOtherServices)
    //   ).toFixed(0);
    // },
    // totalNextNumber() {
    //   return (
    //     Number(this.totalNextNumberResidentialAppraisal) +
    //     Number(this.totalNextNumberCommercialAppraisal) +
    //     Number(this.totalNextNumberRealEstateSales) +
    //     Number(this.totalNextNumberOtherServices)
    //   ).toFixed(0);
    // }
    lastRevenueAuctioneering: {
      get: function () {
        return this.insuranceAgentApplication.lastRevenueAuctioneering || '';
      },
      set: function (val) {
        if (val === '') {
          this.insuranceAgentApplication.lastRevenueAuctioneering = 0;
        } else {

          this.insuranceAgentApplication.lastRevenueAuctioneering = val;
        }
      },
    },
    lastNumberAuctioneering: {
      get: function () {
        return this.insuranceAgentApplication.lastNumberAuctioneering || '';
      },
      set: function (val) {
        if (val === '') {
          this.insuranceAgentApplication.lastNumberAuctioneering = 0;
        } else {

          this.insuranceAgentApplication.lastNumberAuctioneering = val;
        }
      },
    },
    nextRevenueAuctioneering: {
      get: function () {
        return this.insuranceAgentApplication.nextRevenueAuctioneering || '';
      },
      set: function (val) {
        if (val === '') {
          this.insuranceAgentApplication.nextRevenueAuctioneering = 0;
        } else {

          this.insuranceAgentApplication.nextRevenueAuctioneering = val;
        }
      },
    },
    nextNumberAuctioneering: {
      get: function () {
        return this.insuranceAgentApplication.nextNumberAuctioneering || '';
      },
      set: function (val) {
        if (val === '') {
          this.insuranceAgentApplication.nextNumberAuctioneering = 0;
        } else {

          this.insuranceAgentApplication.nextNumberAuctioneering = val;
        }
      },
    },


    lastRevenueShortTermEscrow: {
      get: function () {
        return this.insuranceAgentApplication.lastRevenueShortTermEscrow || '';
      },
      set: function (val) {
        if (val === '') {
          this.insuranceAgentApplication.lastRevenueShortTermEscrow = 0;
        } else {

          this.insuranceAgentApplication.lastRevenueShortTermEscrow = val;
        }
      },
    },
    lastNumberShortTermEscrow: {
      get: function () {
        return this.insuranceAgentApplication.lastNumberShortTermEscrow || '';
      },
      set: function (val) {
        if (val === '') {
          this.insuranceAgentApplication.lastNumberShortTermEscrow = 0;
        } else {

          this.insuranceAgentApplication.lastNumberShortTermEscrow = val;
        }
      },
    },
    nextRevenueShortTermEscrow: {
      get: function () {
        return this.insuranceAgentApplication.nextRevenueShortTermEscrow || '';
      },
      set: function (val) {
        if (val === '') {
          this.insuranceAgentApplication.nextRevenueShortTermEscrow = 0;
        } else {

          this.insuranceAgentApplication.nextRevenueShortTermEscrow = val;
        }
      },
    },
    nextNumberShortTermEscrow: {
      get: function () {
        return this.insuranceAgentApplication.nextNumberShortTermEscrow || '';
      },
      set: function (val) {
        if (val === '') {
          this.insuranceAgentApplication.nextNumberShortTermEscrow = 0;
        } else {

          this.insuranceAgentApplication.nextNumberShortTermEscrow = val;
        }
      },
    },

  },
  watch: {
    errorMsg: {
      handler() {
        if (this.errorMsg) {
          this.$notify({
            group: 'error',
            type: 'error',
            text: this.errorMsg,
            duration: 15000
          });
        }
      }
    }
  },
  methods: {
    prev() {
      this.$router.push({
        name: "ibdpro-insurance-agent-application-1"
      });
    },

    navigateToNext(routeName) {
      this.$router.push({
        name: routeName
      });
    },

    validateBeforeSubmit() {

      // this.insuranceAgentApplication.sumOfPeriod =
      //     Number(this.insuranceAgentApplication.periodOne)
          // Number(this.insuranceAgentApplication.periodTwo);

      this.insuranceAgentApplication.comissionRange =
          (Number(this.insuranceAgentApplication.estimateCommissionEarnOne)/Number(this.insuranceAgentApplication.periodOne)) * 100 ;
          // Number(this.insuranceAgentApplication.estimateCommissionEarnTwo);

      this.$validator.validateAll().then(result => {
        if (result) {
          this.state.pageTwoIsValid = true;
          return;
        }
        this.state.pageTwoIsValid = false;
      });
    },
    validateBeforeSubmitCheck(e){
      this.$validator.validateAll().then(result => {
        if (result) {
          if (this.state.insuranceAgentApplication.realEstateAgentBroker === true){
            this.state.pageTwoIsValid = true;
          }
          else {
          this.state.pageTwoIsValid = false;
          this.validateBeforeSubmit();
          }
          return;
        }
        this.state.pageTwoIsValid = true;

      });
    },
  },

  mounted() {
    this.validateBeforeSubmit();
    $("html, body").animate(
      {
        scrollTop: $(".page-content").offset().top
      },
      500
    );
  },

  filters: {
    filterText(x) {
      if (x !== undefined) {
        if (x.indexOf("req") !== -1) {
          return "This field is required";
        } else {
          return x.replace("_", " ");
        }
      }
    }
  },
  components: {
    Datepicker
  }
};
</script>

<style scoped>
  .red-text {
    color: red;
  }
  table td, table th {
    border: 1px solid black;
  }
  table th {
    height: 35px;
  }
  table td:not(:first-child), table th:not(:first-child) {
    text-align: center;
    max-width: 140px;
  }
  table input {
    width: 100%;
    text-align: center;
  }
</style>
